export default __webpack_public_path__ + "static/agile-devops-73ad20b0bf1777b8bd92e0920a5f480e.jpg";